import { FetchStatus } from '../types';
import { XAuthAction } from './actions';

const defaultUserReducerState = {
  fetchStatus: FetchStatus.UNSETTLED,
  data: {},
  jwt: '',
  refreshToken: ''
};

export const userReducer = (
  state = defaultUserReducerState,
  { type, payload }: { type: XAuthAction; payload?: any }
) => {
  switch (type) {
    case XAuthAction.SET_USER_DATA:
      return { ...state, ...payload };
    case XAuthAction.SET_USER_FETCH_STATUS:
      return { ...state, fetchStatus: payload };
    case XAuthAction.SIGN_OUT:
      return { ...defaultUserReducerState, fetchStatus: FetchStatus.SUCCESS };
    default:
      return state;
  }
};
